import { stringToColor } from './colorUtils';

/**
 * Generates avatar props (sx styles and children) from a name string
 */
export function stringAvatar(name: string) {
    const splitted = name.split(' ');
    const letters = splitted.map(s => s[0]?.toUpperCase() || '');
    const [bg, complementary] = stringToColor(name);
    return {
        sx: {
            bgcolor: bg,
            color: complementary
        },
        children: letters.join(''),
    };
}
